/* global AWIN */
import createAdapter from './createAdapter'
import { getItem, setItem, removeItem } from '../../storeManager'
import { environment } from 'js/config'
import { excludeVAT } from '../../utils'

const saveId = () => {
  if (document.location.pathname.includes('/redeem/awin')) {
    const match = document.location.pathname.match(/\/redeem\/([^/]+)/)
    const awinCode = match ? match[1]?.toLowerCase() : null
    if (awinCode) {
      setItem('awinAwc', awinCode)
    }
  }
}

const awinAdapter = createAdapter(() => !!window.AWIN, {
  trackPurchase(
    transactionId: string,
    coupon: string | null,
    orderValue: number,
    currency: string,
  ) {
    if (!getItem('state')) {
      throw new Error('awinAdapter.ts error: no state saved')
    }

    const { user: userState, locale: localeState } = JSON.parse(
      getItem('state') as string,
    )
    const awc = getItem('awinAwc')
    const userId = userState.profile.id || userState.limitedProfile.id
    const country = userState.profile.country || localeState.country
    let merchantId: string = '113414'

    if (awc && userId) {
      if (!coupon) {
        coupon = null
      } else {
        switch (coupon.toLowerCase()) {
          case 'awinca':
            merchantId = '119213'
            break
          case 'awinus':
            merchantId = '119217'
            break
        }
      }
      console.log('[Awin Tracking] Coupon: ', coupon, merchantId)
      var amount = parseFloat(excludeVAT(orderValue, country)).toFixed(2)

      var awPixel = new Image(0, 0)
      awPixel.src =
        'https://www.awin1.com/sread.img?tt=ns&tv=2&merchant=' +
        merchantId +
        '&amount=' +
        amount +
        '&ch=aw&parts=DEFAULT:' +
        amount +
        '&ref=' +
        transactionId +
        '&vc=' +
        coupon +
        '&cr=' +
        currency +
        '&testmode=' +
        (environment === 'production' ? 0 : 1)
      document.getElementsByTagName('body')[0].appendChild(awPixel)
      console.log('[Awin Tracking] Source: ', awPixel.src)
      AWIN.Tracking.Sale = {
        amount: '' + amount,
        channel: 'aw',
        orderRef: '' + transactionId,
        parts: 'DEFAULT:' + amount,
        currency: '' + currency,
        voucher: '' + coupon,
        test: '' + (environment === 'production' ? 0 : 1),
      }

      AWIN.Tracking.run()

      removeItem('awinAwc')
    }
  },
})

export const awin: typeof awinAdapter & { saveId: typeof saveId } = {
  ...awinAdapter,
  saveId,
}
